import { FleetNotificationService } from "../services/fleet-notification-service";
import { NotificationType } from "../services/types/fleet-notification-service.types";
import { NotificationEvents, VoyFleetNotificationModelBase } from "./voy-fleet-notification-model";
import { VoyagePlan } from "./vessel-planning-model";
import { AuditLog, AuditLogStatus, WeatherRoutingNotification } from "../services/types/fleet-weather-routing-notification.types";
export class VoyFleetNotificationModelImpl extends VoyFleetNotificationModelBase {

   constructor() {
      super();
       this.fetchOfflineVesselNotifications = this.fetchOfflineVesselNotifications.bind(this);
       this.fetchOfflineVesselNotifications()
   }

   private _offlineVesselNotifications: NotificationType[] = [];
   
   private _bprRejectNotificationByVessel = new Map<number, NotificationType[]>();

   public get offlineVesselNotifications(): NotificationType[] {
         return this._offlineVesselNotifications;
   }

   private async _fetchNotificationAllStatus(imo:number, type: string){
      let notifications: any[] = [];
        try {
            notifications = await FleetNotificationService.getNotificationsLog(imo,type)            
  
        } catch(err) {
           console.error(err);
           return;
           
        }
        return notifications;

     }

     public async postFeedback(payload:any){
         try {
            await FleetNotificationService.postFeedback(payload);
         } catch(err) {
            console.error(err);
            return;
         }
     }

     // type param is optional, if provided it will fetch only the notifications of that type (to be expanded if needed)
     public async updateNotification(notificationId: string, payload:any, type?: string){
      try {
         await FleetNotificationService.updateNotification(notificationId, payload);
         if(type === "vesseloffline") {
            await this.fetchOfflineVesselNotifications();
         }
      } catch(err) {
         console.error(err);
         return;
      }
  }
     public async getFeedbackSubmittedHistory(){
         let notifications: any[] = [];
         try {
            notifications = await FleetNotificationService.getFeedbackSubmittedHistory();
         } catch(err) {
            console.error(err);
            return;
         }
         return notifications;
     }

   public getVesselNotificationLog(imo:number, type:string){
      return this._fetchNotificationAllStatus(imo, type);
   }
   getBprInformationNotification(imo: number){
      return this._bprRejectNotificationByVessel.get(imo);
   }
   async fetchBprInformationNotification(imo: number, type: string) {
      try {
         return await FleetNotificationService.getBprInformation(imo, type)
      } catch (err) {
         console.error(err);
         return;
      }
   }

   public getFilteredBprInformation(imo: number | undefined, plan: VoyagePlan) {
      if (!imo)
          return;
      const notifications = this.getBprInformationNotification(imo);
      if (notifications && notifications.length) {
          const currentScheduleNotification = notifications.find(notification => {
              return JSON.parse(notification.data).scheduleId == plan?.scheduleId;
          });
          if (currentScheduleNotification) {
              return JSON.parse(currentScheduleNotification?.notification_responses[0]?.data) || null;
          }
      }
  }
   public async getBprRejectLog(type: string){
      let notifications: any[] = [];
      try {
         notifications = await FleetNotificationService.getAllNotifications(type);
      } catch(err) {
         console.error(err);
         return;
      }
      return notifications;
   }

   public async getWeatherRoutingNotifications(imo: number = 0): Promise<AuditLog[]> {
      let notifications: WeatherRoutingNotification[] = [];
      let auditLogs: AuditLog[] = [];
  
      try {
          notifications = await FleetNotificationService.getWeatherRoutingNotifications(imo);
          notifications?.forEach(notification => {
              const logs = notification.audit_logs.map(log => ({
                  ...log,
                  schedule_id: notification.schedule_id,
                  terminal_from: notification.terminal_from,
                  terminal_to: notification.terminal_to
              }));
              auditLogs.push(...logs);
          });

          // Define priority order for statuses
          const statusOrder: Record<string, number> = {
              [AuditLogStatus.WRADVICEREJECTED]: 0,
              [AuditLogStatus.WRADVICESAFETYCHECKED]: 1,
          };
  
          // Sorting logic
          auditLogs.sort((a, b) => {
              // Ensure `mst_status_name` exists before checking
              const aStatus = a.mst_status_name || "";
              const bStatus = b.mst_status_name || "";
  
              // Get priority, defaulting to 2 if not found
              const aPriority = statusOrder[aStatus] ?? 2;
              const bPriority = statusOrder[bStatus] ?? 2;
  
              // Compare based on priority first
              if (aPriority !== bPriority) {
                  return aPriority - bPriority;
              }
  
              // If priorities are the same, sort by `created_at` (latest first)
              return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
          });
  
      } catch (err) {
          console.error(err);
          return [];
      }
  
      return auditLogs;
   }

   public async updateWeatherRoutingNotifications(payload: any){
      try {
         await FleetNotificationService.updateWeatherRoutingNotifications(payload);
      } catch(err) {
         console.error(err);
         return;
      }
   }

  public async fetchOfflineVesselNotifications() {
    try {
      this._offlineVesselNotifications =
        await FleetNotificationService.getOfflineVesselNotifications();

      if (this._offlineVesselNotifications) {
        this.dispatchEvent(
          new Event(NotificationEvents.OfflineNotificationsUpdated)
        );
      }
    } catch (err) {
      console.error(err);
      return;
    }
  }
}